import React from 'react';
import ComingSoon from '../components/UI/coming-soon/ComingSoon';

const ReportPage: React.FC = () => {
  return (
    <div className='page'>
      <ComingSoon />
    </div>
  );
};

export default ReportPage;
